import styles from "./blog.module.css";
import { useEffect, useRef, useState } from "react";
import Footer from "../footer/footer";
import Button from "./../../components/button/button";

const Blog = () => {
  const [opacity, setOpacity] = useState(window.innerWidth > 650 ? 1 : 0);

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    if (window.innerWidth > 650) return;

    const handleScroll = () => {
      const { top } = sectionRef.current.getBoundingClientRect();

      let opacity;

      if (top > 0) {
        opacity = Math.max(
          0,
          Math.min(1, (window.innerHeight - top) / window.innerHeight)
        );
      } else {
        opacity = 1;
      }

      setOpacity(opacity);
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const sectionRef = useRef(null);

  useEffect(() => {
    const initLoad = () => {
      fetch(process.env.PUBLIC_URL + "/json/blog.json")
        .then((res) => res.json())
        .then((data) => {
          setBlogs([...data]);
        });
    };

    initLoad();
  }, []);

  return (
    <div
      id="section3"
      className={styles.blogWrapper}
      ref={sectionRef}
      style={{ opacity }}
    >
      <div className={styles.blog}>
        <div className="narrow-container">
          <div className={styles.top}>
            <h2>
              {blogs[0]?.titleLine1} <br /> {blogs[0]?.titleLine2}
            </h2>

            <Button>See all posts</Button>
          </div>
        </div>

        <div className={`${styles.blogSlider} container`}>
          <div className={`${styles.blogs}`}>
            {blogs[0]?.posts?.map((blog, index) => (
              <div key={index} className={styles.blogCard}>
                <div className={styles.blogImage}>
                  <img
                    src={
                      process.env.PUBLIC_URL + `/json/blogImage/${blog?.image}`
                    }
                    fill
                    alt=""
                  />
                </div>
                <div className={styles.date}>
                  <div className={styles.dateBox}></div>

                  <p>{blog.date}</p>
                </div>
                <div className={styles.label}>{blog.label}</div>
                <div className={styles.text}>{blog.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer data={blogs[0]?.contact} />
    </div>
  );
};

export default Blog;
